.container {
  padding: 24px;
  width: 100%;
  max-width: 1200px;
  min-width: 650px;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .container {
    padding: 16px;
    min-width: unset;
    width: 100%;
  }
}

.header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--box-divider-color);
}

.title {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--main-text);
  margin: 0;
}
